import urchin from './vendor/urchin';

// DavidWells/analytics uses this to determine what happens when that module's methods are called
/**
 * Analytics provider plugin for Urchin
 * @returns {import('analytics').AnalyticsPlugin}
 */
export default function createUrchinAnalyticsPlugin () {
    return {
        /* All plugins require a name */
        name: 'urchin',
        page: ({ payload }) => {
            const {
                loggedIn,
                channel,
                affiliateId,
                page,
            } = payload.properties;

            try {
                // r = registered (indicates if user already registered), c = channel,
                // d = device, a = affiliate
                const userData = 'r=' + (loggedIn ? '1' : '0') + ';c=' + channel +
                ';d=def' + ';a=' + affiliateId;

                // __utmSetVar tells the Urchin library what the current state of our application is
                // urchinTracker then sends that data to the server alongside the current page name
                urchin.__utmSetVar(userData);
                urchin.urchinTracker(page, undefined, payload.properties.callback);
            }
            catch (err) {
                console.warn(`Urchin.trackPageView error: ${err}`);
                if (typeof callback === 'function') payload.properties.callback();
            }
        },
        track: ({ payload }) => {
            const
                { event } = payload,
                {
                    category,
                    label,
                    value,
                    page,
                    callback,
                } = payload.properties;

            urchin.__utmTrackEvent(category, event, label || '', value || '', page, callback);
        },
        // We didn't have any way of knowing that urchin loaded previously,
        // so this is an equally naive way of ensuring it loads before calling tracking methods
        loaded: () => true,
    };
}
